import { useState } from "react";
import axios from "axios";
import { apiPath, apiUpload, basePath } from "../apiPath";
const finalPath = apiPath + apiUpload;

//https://codeparrot.ai/blogs/how-to-implement-mui-file-upload-in-react-using-vite-and-axios-a-comprehensive-guide
const useFileUpload = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const uploadFile = async (file) => {
    setUploadProgress(0);
    setUploadComplete(false);
    setUploadError(null);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "caseStudy");
    formData.append("subtype", "thumnail");
    try {
      const response = await axios.post(finalPath, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });
      setUploadComplete(true);
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadError("Failed to upload file. Please try again.");
    }
  };

  return { uploadProgress, uploadComplete, uploadError, uploadFile };
};
export default useFileUpload;
